import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/home'
import SearchList from '@/components/searchlist/searchlist'
import dataCount from '@/components/dataCount/dataCount'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/searchlist',
      name: 'SearchList',
      component: SearchList
    },
    {
      path: '/datacount',
      name: 'dataStatistics',
      component: dataCount
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js